"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var hyperlink_1 = require("@csod/hyperlink");
var MonthPicker_1 = require("./MonthPicker");
var YearPicker_1 = require("./YearPicker");
var types_1 = require("../../types");
exports.YEARS_IN_RANGE = 10;
var NavbarElement = /** @class */ (function (_super) {
    __extends(NavbarElement, _super);
    function NavbarElement(props) {
        var _this = _super.call(this, props) || this;
        _this._monthRows = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]];
        _this._getYearGridOptions = _this._getYearGridOptions.bind(_this);
        _this._getYearRange = _this._getYearRange.bind(_this);
        _this._handleChange = _this._handleChange.bind(_this);
        _this._handleNext = _this._handleNext.bind(_this);
        _this._handlePrevious = _this._handlePrevious.bind(_this);
        _this._handleSelectorChange = _this._handleSelectorChange.bind(_this);
        _this._renderSelector = _this._renderSelector.bind(_this);
        _this._updateRangeAndOptions = _this._updateRangeAndOptions.bind(_this);
        _this.state = {
            month: 0,
            monthNames: [],
            monthNamesLong: [],
            monthYear: 0,
            year: 0,
            yearRange: [],
            yearRows: []
        };
        return _this;
    }
    NavbarElement.prototype._getYearRange = function (year) {
        var range = [];
        var yearsAfter = Math.floor(exports.YEARS_IN_RANGE / 2);
        for (var i = year - (exports.YEARS_IN_RANGE - yearsAfter); i < year + yearsAfter; i = i + 1) {
            range.push(i);
        }
        return range;
    };
    NavbarElement.prototype._getYearGridOptions = function (yearRange) {
        var options = [[], [], []];
        yearRange.forEach(function (year, i) {
            var row = Math.floor(i / 4);
            options[row].push(year);
        });
        return options;
    };
    NavbarElement.prototype._updateRangeAndOptions = function (year) {
        var yearRange = this._getYearRange(year);
        var yearOptions = this._getYearGridOptions(yearRange);
        this.setState({
            yearRows: yearOptions,
            yearRange: yearRange
        });
    };
    NavbarElement.prototype.componentDidMount = function () {
        var _a = this.props, date = _a.date, localeUtils = _a.localeUtils;
        this.setState({
            month: date.getMonth(),
            monthNames: localeUtils.getMonths(),
            monthNamesLong: localeUtils.getMonthsLong(),
            monthYear: date.getFullYear(),
            year: date.getFullYear()
        });
        this._updateRangeAndOptions(date.getFullYear());
    };
    NavbarElement.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, date = _a.date, previousMonth = _a.previousMonth;
        if (date !== prevProps.date) {
            this.setState({
                month: date.getMonth(),
                monthYear: date.getFullYear(),
                year: date.getFullYear()
            });
            this._updateRangeAndOptions(date.getFullYear());
        }
        if (previousMonth !== prevProps.previousMonth) {
            var prevMonth = previousMonth.getMonth();
            var newMonth = prevMonth + 1 > 11 ? 0 : prevMonth + 1;
            var newYear = newMonth === 0 ? previousMonth.getFullYear() + 1 : previousMonth.getFullYear();
            this.setState({
                month: newMonth,
                monthYear: newYear,
                year: newYear
            });
            this._updateRangeAndOptions(newYear);
        }
    };
    NavbarElement.prototype._handleSelectorChange = function (e) {
        e.preventDefault();
        var nextSelector;
        switch (this.props.currentSelector) {
            case types_1.Selector.DAY:
                nextSelector = types_1.Selector.MONTH;
                break;
            case types_1.Selector.MONTH:
                nextSelector = types_1.Selector.YEAR;
                break;
            default:
                nextSelector = types_1.Selector.DAY;
                this.props.onCloseSelector && this.props.onCloseSelector();
                break;
        }
        this.props.onSelectorChange && this.props.onSelectorChange(nextSelector);
    };
    NavbarElement.prototype._handleChange = function (month, year) {
        var newDate = new Date(year, month);
        this.props.onChange && this.props.onChange(newDate);
        var nextSelector = types_1.Selector.DAY;
        if (this.props.currentSelector === types_1.Selector.YEAR) {
            nextSelector = types_1.Selector.MONTH;
        }
        this.setState({
            month: month,
            monthYear: year,
            year: year
        });
        this.props.onSelectorChange && this.props.onSelectorChange(nextSelector);
        if (nextSelector === types_1.Selector.DAY) {
            this.props.onCloseSelector && this.props.onCloseSelector();
        }
    };
    NavbarElement.prototype._handlePrevious = function () {
        var _a = this.props, currentSelector = _a.currentSelector, previousMonth = _a.previousMonth;
        var monthYear = this.state.monthYear;
        switch (currentSelector) {
            case types_1.Selector.MONTH:
                this.setState({
                    monthYear: monthYear - 1
                });
                break;
            case types_1.Selector.YEAR:
                this._updateRangeAndOptions(monthYear - exports.YEARS_IN_RANGE);
                this.setState({
                    monthYear: monthYear - exports.YEARS_IN_RANGE
                });
                break;
            default:
                this.setState({
                    month: previousMonth.getMonth(),
                    monthYear: previousMonth.getFullYear()
                });
                this.props.onPreviousClick && this.props.onPreviousClick();
                break;
        }
    };
    NavbarElement.prototype._handleNext = function () {
        var _a = this.props, currentSelector = _a.currentSelector, nextMonth = _a.nextMonth;
        var monthYear = this.state.monthYear;
        switch (currentSelector) {
            case types_1.Selector.MONTH:
                this.setState({
                    monthYear: monthYear + 1
                });
                break;
            case types_1.Selector.YEAR:
                this._updateRangeAndOptions(monthYear + exports.YEARS_IN_RANGE);
                this.setState({
                    monthYear: monthYear + exports.YEARS_IN_RANGE
                });
                break;
            default:
                this.setState({
                    month: nextMonth.getMonth(),
                    monthYear: nextMonth.getFullYear()
                });
                this.props.onNextClick && this.props.onNextClick();
                break;
        }
    };
    NavbarElement.prototype._renderSelector = function () {
        var _a = this.props, classNames = _a.classNames, currentSelector = _a.currentSelector, date = _a.date, onCloseCalendar = _a.onCloseCalendar;
        var _b = this.state, month = _b.month, monthNames = _b.monthNames, monthNamesLong = _b.monthNamesLong, monthYear = _b.monthYear, year = _b.year, yearRange = _b.yearRange, yearRows = _b.yearRows;
        switch (currentSelector) {
            case types_1.Selector.MONTH:
                return (React.createElement(MonthPicker_1.default, { classNames: classNames, initialDate: date, month: month, monthNames: monthNames, monthNamesLong: monthNamesLong, monthRows: this._monthRows, monthYear: monthYear, onChange: this._handleChange, onNext: this._handleNext, onPrev: this._handlePrevious, onCloseCalendar: onCloseCalendar }));
            case types_1.Selector.YEAR:
                return (React.createElement(YearPicker_1.default, { classNames: classNames, initialDate: date, year: year, yearRange: yearRange, yearRows: yearRows, onChange: this._handleChange, onNext: this._handleNext, onPrev: this._handlePrevious, onCloseCalendar: onCloseCalendar }));
            default:
                return null;
        }
    };
    NavbarElement.prototype.render = function () {
        var _a = this.props, classNames = _a.classNames, currentSelector = _a.currentSelector, labels = _a.labels;
        var _b = this.state, month = _b.month, monthNamesLong = _b.monthNamesLong, monthYear = _b.monthYear, yearRange = _b.yearRange;
        var linkLabel = '';
        switch (currentSelector) {
            case types_1.Selector.MONTH:
                linkLabel = "" + monthYear;
                break;
            case types_1.Selector.YEAR:
                linkLabel = yearRange[0] + " - " + yearRange[yearRange.length - 1];
                break;
            default:
                linkLabel = monthNamesLong[month] + " " + monthYear;
                break;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames.navBar + " custom" },
                React.createElement("span", { tabIndex: 0, role: "button", "aria-label": labels.previousMonth, className: classNames.navButtonPrev, onClick: this._handlePrevious }),
                React.createElement(hyperlink_1.default, { type: "Action", text: linkLabel, onClick: this._handleSelectorChange }),
                React.createElement("span", { tabIndex: 0, role: "button", "aria-label": labels.nextMonth, className: classNames.navButtonNext, onClick: this._handleNext })),
            this._renderSelector()));
    };
    return NavbarElement;
}(React.Component));
exports.default = NavbarElement;
//# sourceMappingURL=Navbar.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/date-picker/build/control/components/Navbar.js
// module id = 281
// module chunks = 0 1